import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=1d5dce04"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5dce04')) {
      api.createRecord('1d5dce04', component.options)
    } else {
      api.reload('1d5dce04', component.options)
    }
    module.hot.accept("./BaseButton.vue?vue&type=template&id=1d5dce04", function () {
      api.rerender('1d5dce04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/BaseButton.vue"
export default component.exports